export default __webpack_public_path__ + "static/media/pictogramBeaconBNPL48.5d2535f3.svg";